import utils from '@/utils';
import { request } from '@/api/service';
export default {
  methods: {
    handleMenuSelect: function handleMenuSelect(index, indexPath) {
      if (/^d2-menu-empty-\d+$/.test(index) || index === undefined) {
        this.$message.warning('临时菜单');
      } else if (/^https:\/\/|http:\/\//.test(index)) {
        if (index.indexOf('sms') != -1 && index.indexOf('recharge') != -1) {
          /* request({
            method: 'post',
            url: '/api/sms-recharge/create',
            data: {
              'mobile': utils.cookies.get('phone')
            }
          }).then((res) => {
            var app_id = res.app_id
            var sign = res.sign
            var market_id = res.market_id
            var order_no = res.order_no
            index = index + '?app_id=' + app_id + '&sign=' + sign + '&market_id=' + market_id + '&order_no=' + order_no
            utils.open(index)
          }) */
          // this.closeBy(page => page.name === 'management-sms-recharge')
          this.$router.push({
            name: 'management-sms-recharge',
            query: {
              market_mobile: utils.cookies.get('phone')
            }
          });
        } else {
          utils.open(index);
        }
      } else {
        this.$router.push({
          path: index
        });
      }
    }
  }
};